var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-text-field',{attrs:{"value":_vm.value,"type":"number","min":_vm.min,"max":_vm.max,"label":_vm.title,"outlined":""},on:{"click":function($event){$event.stopPropagation();return _vm.clicked.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }